import { Link } from "react-router-dom";
import { Phone, CalendarCheck, MessageSquareText } from "lucide-react";
import { SITE } from "@/data/site";

export default function CtaBlock({ heading = "Ready to get your VIN verified?", sub }) {
  return (
    <section className="bg-brand rounded-3xl px-6 sm:px-10 py-12 text-center" data-testid="cta-block">
      <h2 className="font-display font-bold text-white text-2xl sm:text-3xl lg:text-4xl">{heading}</h2>
      {sub && <p className="text-white/80 mt-3 max-w-2xl mx-auto">{sub}</p>}
      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <a href={SITE.phoneHref} data-testid="cta-call" className="btn-accent rounded-full px-7 py-4 text-base font-semibold flex items-center gap-2 w-full sm:w-auto justify-center">
          <Phone size={18} /> Call Now
        </a>
        <Link to="/book" data-testid="cta-quote" className="rounded-full px-7 py-4 text-base font-semibold bg-white text-brand hover:bg-white/90 transition-colors flex items-center gap-2 w-full sm:w-auto justify-center">
          <CalendarCheck size={18} /> Book Appointment
        </Link>
        <a href={SITE.sms} data-testid="cta-sms" className="rounded-full px-7 py-4 text-base font-semibold border border-white/40 text-white hover:bg-white/10 transition-colors flex items-center gap-2 w-full sm:w-auto justify-center">
          <MessageSquareText size={18} /> Text Us
        </a>
      </div>
    </section>
  );
}
